// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"145501dd","384":"b48fb51c","531":"6e8aa004","694":"63d30a97","915":"4a4e8503"}[chunkId] + ".chunk.js";
};